import React, { useEffect, useState } from 'react';
import { gql, useQuery, useMutation } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';
import { isLoggedVar } from './cache';
import { UPDATE_TOKEN } from './query';
import CustomAlert from '../common/alert';
import { LOGIN_USER } from '../../presentation/containers/login/queries';

const Auth = ({ children }: { children: any }) => {
  const navigate = useNavigate();

  const [updateToken, { data, called }] = useMutation(UPDATE_TOKEN);
  const [isMount, setIsMount] = useState(false);
  const [validatedToken, setValidatedToken] = useState<boolean>();
  const location = useLocation();
  // Actualiza el auth token del usuario por cada cambio de ventana
  const { data: dataLogged } = useQuery(gql`
    query IsUserLoggedIn {
      isLogged @client
    }
  `);

  const [login] = useMutation(LOGIN_USER);

  useEffect(() => {
    const searchParams = location.search.replace('?', '');
    if (searchParams) {
      const [tiId, uIdeNum, uPass] = searchParams.split(',');
      const params = { tiId, uIdeNum, uPass };

      login({ variables: { input: params } })
        .then(({ data: dataLogin }) => {
          const { userAdminLogin } = dataLogin;
          if (userAdminLogin) {
            setValidatedToken(true);

            localStorage.setItem('uId', userAdminLogin?.uId);
            localStorage.setItem('ucId', userAdminLogin?.ucId);
            localStorage.setItem('tokenAuth', userAdminLogin?.tokenAuth);
            localStorage.setItem('profile', JSON.stringify(userAdminLogin?.profileAdminUser || {}));

            navigate(location.pathname, { replace: true });
          } else {
            setValidatedToken(false);
          }
        })
        .catch(() => localStorage.clear());
    }
  }, [location.search, login]);

  // Verifica el token
  useEffect(() => {
    if (validatedToken !== undefined) {
      updateToken().catch(() => setIsMount(true));
    }
  }, [updateToken, validatedToken]);

  // Respuesta de la verificación del token
  useEffect(() => {
    const res = data?.refreshUserPayrollToken;
    if ((called && res) || validatedToken) {
      setIsMount(true);
      if (res?.tokenAuth || validatedToken) {
        if (res?.tokenAuth) {
          localStorage.setItem('tokenAuth', res?.tokenAuth);
        }
        isLoggedVar({ state: true, expired: false, code: '', message: '' });
        setValidatedToken(undefined);
      } else {
        localStorage.clear();
        const response = localStorage.getItem('tokenAuth');
        isLoggedVar({
          state: false,
          expired: true,
          message: (typeof response === 'string' ? response : '') && 'La sesión ha expirado',
          code: '403',
        });
      }
    }
  }, [data, called, validatedToken]);

  useEffect(() => {
    const res = dataLogged.isLogged;
    if (res.message) {
      isLoggedVar({ ...isLoggedVar(), message: '' });
      if (res.code >= 500 && res.message !== 'No se ha encontrado ningún resultado.')
        <CustomAlert message={res.message} type="error" />;
      else if (
        res.code >= 400 &&
        res.code !== 403 &&
        res.message !== 'No se ha encontrado ningún resultado.'
      )
        <CustomAlert message={res.message} type="warning" />;
      else if (
        (res.code >= 300 || res.code === 403) &&
        res.message !== 'No se ha encontrado ningún resultado.'
      )
        <CustomAlert message={res.message} type="info" />;
      else if (res.code >= 200 && res.message !== 'No se ha encontrado ningún resultado.')
        <CustomAlert message={res.message} type="success" />;
    }
  }, [dataLogged.isLogged]);

  useEffect(() => {
    updateToken().catch(() => setIsMount(true));
  }, [location.pathname, updateToken]);

  return <>{children(dataLogged.isLogged, isMount)}</>;
};

export default Auth;
